import * as React from "react";

export const ArthaLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={112}
    height={26}
    viewBox="0 0 112 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.4886 23.8976C22.9752 19.2851 19.3275 15.6895 14.7596 14.3643C10.0458 15.74 6.29683 19.3411 4.7567 23.9376L4.736 23.9997L2.69775 23.744C2.87712 20.1998 4.29999 16.9793 6.54383 14.5L6.55328 14.4894C8.65582 12.1705 11.4773 10.5017 14.6712 9.8252C17.6702 10.4554 20.3434 11.9466 22.4086 14.022L22.4424 14.0991L22.4656 14.152L22.5573 14.1736C24.9837 16.681 26.5366 20.0091 26.738 23.6892L24.5116 23.9685L24.4886 23.8976Z"
      fill="url(#paint0_linear_5388_3842)"
    />
    <g filter="url(#filter0_f_5388_3842)">
      <path
        d="M3.83764 23.5331L4.17725 19.9097L4.54404 18.177L5.278 15.9824L6.22038 14.086"
        stroke="#101828"
        strokeWidth={0.644295}
      />
    </g>
    <g filter="url(#filter1_f_5388_3842)">
      <path
        d="M25.5876 23.4527L25.2308 19.6451L24.8454 17.8244L24.0741 15.5184L23.0838 13.5256"
        stroke="#101828"
        strokeWidth={0.644295}
      />
    </g>
    <path
      d="M9.42715 2.8772C10.9931 1.67109 12.7066 0.697629 14.5299 0C16.3692 0.707076 18.0962 1.69725 19.672 2.92589C22.7288 5.30935 25.2163 8.58977 26.8505 12.4394C27.4609 13.8775 27.9522 15.395 28.3097 16.9749C28.7558 18.9471 28.9933 21.0165 28.9933 23.1498L28.9932 23.2145L28.9929 23.3077L28.9921 23.407L26.7333 23.6906L24.4931 23.9916V23.8983C24.4971 23.8075 24.5006 23.7166 24.5037 23.6255C24.507 23.5289 24.5096 23.4321 24.5117 23.3352C24.5158 23.15 24.5178 22.9641 24.5178 22.7777C24.3405 19.7269 23.6171 16.8072 22.4785 14.1867C22.4275 14.0694 22.5005 14.2355 22.4217 14.0571C21.7216 12.471 20.8689 10.9964 19.8932 9.67109C18.4077 7.65357 16.637 5.98207 14.6846 4.78987C12.6842 5.98622 10.8719 7.66281 9.3614 9.68926C8.28139 11.1382 7.35569 12.766 6.6258 14.5249L6.62228 14.5334C5.57572 17.0585 4.93258 19.8535 4.816 22.7777C4.816 23.1672 4.82493 23.5541 4.84251 23.9381L4.82189 24L2.79204 23.7452L0.00104514 23.3949L0.000475063 23.3061C0.000190025 23.254 0 23.2019 0 23.1498C0 21.6115 0.124086 20.1065 0.361333 18.6472C0.694637 16.5972 1.25113 14.6375 2.00106 12.8025C3.64924 8.76947 6.23112 5.33873 9.42715 2.8772Z"
      fill="white"
    />
    <path
      d="M9.42715 2.8772C10.9931 1.67109 12.7066 0.697629 14.5299 0C16.3692 0.707076 18.0962 1.69725 19.672 2.92589C22.7288 5.30935 25.2163 8.58977 26.8505 12.4394C27.4609 13.8775 27.9522 15.395 28.3097 16.9749C28.7558 18.9471 28.9933 21.0165 28.9933 23.1498L28.9932 23.2145L28.9929 23.3077L28.9921 23.407L26.7333 23.6906L24.4931 23.9916V23.8983C24.4971 23.8075 24.5006 23.7166 24.5037 23.6255C24.507 23.5289 24.5096 23.4321 24.5117 23.3352C24.5158 23.15 24.5178 22.9641 24.5178 22.7777C24.3405 19.7269 23.6171 16.8072 22.4785 14.1867C22.4275 14.0694 22.5005 14.2355 22.4217 14.0571C21.7216 12.471 20.8689 10.9964 19.8932 9.67109C18.4077 7.65357 16.637 5.98207 14.6846 4.78987C12.6842 5.98622 10.8719 7.66281 9.3614 9.68926C8.28139 11.1382 7.35569 12.766 6.6258 14.5249L6.62228 14.5334C5.57572 17.0585 4.93258 19.8535 4.816 22.7777C4.816 23.1672 4.82493 23.5541 4.84251 23.9381L4.82189 24L2.79204 23.7452L0.00104514 23.3949L0.000475063 23.3061C0.000190025 23.254 0 23.2019 0 23.1498C0 21.6115 0.124086 20.1065 0.361333 18.6472C0.694637 16.5972 1.25113 14.6375 2.00106 12.8025C3.64924 8.76947 6.23112 5.33873 9.42715 2.8772Z"
      fill="url(#paint1_linear_5388_3842)"
    />
    <path
      d="M9.42715 2.8772C10.9931 1.67109 12.7066 0.697629 14.5299 0C16.3692 0.707076 18.0962 1.69725 19.672 2.92589C22.7288 5.30935 25.2163 8.58977 26.8505 12.4394C27.4609 13.8775 27.9522 15.395 28.3097 16.9749C28.7558 18.9471 28.9933 21.0165 28.9933 23.1498L28.9932 23.2145L28.9929 23.3077L28.9921 23.407L26.7333 23.6906L24.4931 23.9916V23.8983C24.4971 23.8075 24.5006 23.7166 24.5037 23.6255C24.507 23.5289 24.5096 23.4321 24.5117 23.3352C24.5158 23.15 24.5178 22.9641 24.5178 22.7777C24.3405 19.7269 23.6171 16.8072 22.4785 14.1867C22.4275 14.0694 22.5005 14.2355 22.4217 14.0571C21.7216 12.471 20.8689 10.9964 19.8932 9.67109C18.4077 7.65357 16.637 5.98207 14.6846 4.78987C12.6842 5.98622 10.8719 7.66281 9.3614 9.68926C8.28139 11.1382 7.35569 12.766 6.6258 14.5249L6.62228 14.5334C5.57572 17.0585 4.93258 19.8535 4.816 22.7777C4.816 23.1672 4.82493 23.5541 4.84251 23.9381L4.82189 24L2.79204 23.7452L0.00104514 23.3949L0.000475063 23.3061C0.000190025 23.254 0 23.2019 0 23.1498C0 21.6115 0.124086 20.1065 0.361333 18.6472C0.694637 16.5972 1.25113 14.6375 2.00106 12.8025C3.64924 8.76947 6.23112 5.33873 9.42715 2.8772Z"
      fill="url(#paint2_linear_5388_3842)"
    />
    <path
      d="M36.8622 23L44.0582 2.14H48.9862L56.1822 23H52.0382L50.5542 18.52H42.4902L40.9782 23H36.8622ZM43.5822 15.16H49.4622L45.9902 4.772H47.0542L43.5822 15.16ZM58.1958 23V7.768H61.6398V11.156L61.3598 10.652C61.7145 9.51333 62.2651 8.72 63.0118 8.272C63.7771 7.824 64.6918 7.6 65.7558 7.6H66.6518V10.848H65.3358C64.2905 10.848 63.4505 11.1747 62.8158 11.828C62.1811 12.4627 61.8638 13.3587 61.8638 14.516V23H58.1958ZM76.0226 23.168C74.3053 23.168 72.9706 22.7013 72.0186 21.768C71.0853 20.816 70.6186 19.4813 70.6186 17.764V11.044H67.9866V7.768H68.2666C69.0133 7.768 69.5919 7.572 70.0026 7.18C70.4133 6.788 70.6186 6.21867 70.6186 5.472V4.296H74.2866V7.768H77.7866V11.044H74.2866V17.568C74.2866 18.072 74.3706 18.5013 74.5386 18.856C74.7253 19.2107 75.0053 19.4813 75.3786 19.668C75.7706 19.8547 76.2653 19.948 76.8626 19.948C76.9933 19.948 77.1426 19.9387 77.3106 19.92C77.4973 19.9013 77.6746 19.8827 77.8426 19.864V23C77.5813 23.0373 77.2826 23.0747 76.9466 23.112C76.6106 23.1493 76.3026 23.168 76.0226 23.168ZM80.645 23V1.804H84.313V10.764L83.809 10.232C84.1637 9.31733 84.7423 8.62667 85.545 8.16C86.3663 7.67467 87.3183 7.432 88.401 7.432C89.521 7.432 90.5103 7.67467 91.369 8.16C92.2463 8.64533 92.9277 9.32667 93.413 10.204C93.8983 11.0627 94.141 12.0613 94.141 13.2V23H90.473V14.068C90.473 13.396 90.3423 12.8173 90.081 12.332C89.8197 11.8467 89.4557 11.4733 88.989 11.212C88.541 10.932 88.009 10.792 87.393 10.792C86.7957 10.792 86.2637 10.932 85.797 11.212C85.3303 11.4733 84.9663 11.8467 84.705 12.332C84.4437 12.8173 84.313 13.396 84.313 14.068V23H80.645ZM101.863 23.336C100.799 23.336 99.8747 23.1587 99.0907 22.804C98.3067 22.4493 97.7 21.9453 97.2707 21.292C96.8413 20.62 96.6267 19.8453 96.6267 18.968C96.6267 18.128 96.8133 17.3813 97.1867 16.728C97.56 16.056 98.1387 15.496 98.9227 15.048C99.7067 14.6 100.696 14.2827 101.891 14.096L106.875 13.284V16.084L102.591 16.812C101.863 16.9427 101.321 17.176 100.967 17.512C100.612 17.848 100.435 18.2867 100.435 18.828C100.435 19.3507 100.631 19.7707 101.023 20.088C101.433 20.3867 101.937 20.536 102.535 20.536C103.3 20.536 103.972 20.3773 104.551 20.06C105.148 19.724 105.605 19.2667 105.923 18.688C106.259 18.1093 106.427 17.4747 106.427 16.784V12.864C106.427 12.2107 106.165 11.6693 105.643 11.24C105.139 10.792 104.467 10.568 103.627 10.568C102.843 10.568 102.143 10.7827 101.527 11.212C100.929 11.6227 100.491 12.1733 100.211 12.864L97.2147 11.408C97.5133 10.6053 97.98 9.91467 98.6147 9.336C99.268 8.73867 100.033 8.272 100.911 7.936C101.788 7.6 102.74 7.432 103.767 7.432C105.017 7.432 106.119 7.66533 107.071 8.132C108.023 8.58 108.76 9.21467 109.283 10.036C109.824 10.8387 110.095 11.7813 110.095 12.864V23H106.623V20.396L107.407 20.34C107.015 20.9933 106.548 21.544 106.007 21.992C105.465 22.4213 104.849 22.7573 104.159 23C103.468 23.224 102.703 23.336 101.863 23.336Z"
      fill="#101828"
    />
    <defs>
      <filter
        id="filter0_f_5388_3842"
        x={1.50367}
        y={11.929}
        width={7.01854}
        height={13.6479}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={1.00671}
          result="effect1_foregroundBlur_5388_3842"
        />
      </filter>
      <filter
        id="filter1_f_5388_3842"
        x={20.782}
        y={11.3684}
        width={7.13964}
        height={14.1274}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={1.00671}
          result="effect1_foregroundBlur_5388_3842"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5388_3842"
        x1={14.738}
        y1={20.1138}
        x2={14.8752}
        y2={9.8267}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0D41E1" />
        <stop offset={1} stopColor="#07C8F9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5388_3842"
        x1={14.6029}
        y1={0.00000188393}
        x2={14.3079}
        y2={23.999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FC7C01" />
        <stop offset={0.699677} stopColor="#F76173" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5388_3842"
        x1={13.4407}
        y1={6.94815}
        x2={13.1491}
        y2={23.7656}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15FAD" />
        <stop offset={0.6} stopColor="#F76173" />
      </linearGradient>
    </defs>
  </svg>
);
